/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:view
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/21 | 富士通株式会社         | 新規作成
// 01.02.00 | 2023/08/07 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
//================================================================================
 */
//import { PATH_LOGIN } from '@/const/route.js';
import router from '@/router/router.js';

export const view = {
	namespaced: true,
	state: {
		name: '画面ID',
		title: '画面名',
		progressFlg: false,		// プログレスバー表示有無
		currentPage: 0,			// (ページ制御)表示ページ
		displayCount: 0,		// (ページ制御)表示件数
		sortOrder: '',			// (ページ制御)ソート順
		mobileFlg: false,		// モバイル有無
		browserBackFlg: false,	// ブラウザバック実行有無
		viewParams: {},			// 画面遷移項目
	},
	getters: {
		// 戻り先のルート情報(URL含む)を取得
		getBackURL(state) {
			// 要素の最後はcurrentのルート情報(URL含む)
			return state.history[state.history.length - 2];
		},
		// 画面IDを取得
		getName(state) {
			return state.name;
		},
		// 画面名を取得
		getTitle(state) {
			return state.title;
		},
		// プログレス表示フラグを取得
		isProgressFlg(state) {
			return state.progressFlg;
		},
		// 一覧の表示ページ番号を取得
		getCurrentPage(state) {
			return state.currentPage;
		},
		// 一覧の表示件数を取得
		getDisplayCount(state) {
			return state.displayCount;
		},
		// 一覧の並び替えを取得
		getSortOrder(state) {
			return state.sortOrder;
		},
		// モバイル表示有無を取得
		getMobileFlg(state) {
			return state.mobileFlg;
		},
		// ブラウザバックフラグを取得
		getBrowserBackFlg(state) {
			return state.browserBackFlg;
		},
		// 呼出元の画面のparamsを取得
		getParams(state) { return function() {
				let id = router.currentRoute._value.name;
				return state.viewParams[id];
			}
		}
	},
	mutations: {
		/**
		 * 画面ID設定
		 * @param {Object} state 状態
		 * @param {String} name 画面ID
		 */
		setName(state, name) {
			state.name = name;
		},
		/**
		 * 画面名設定
		 * @param {Object} state 状態
		 * @param {String} title 画面名
		 */
		setTitle(state, title) {
			state.title = title;
		},
		/**
		 * プログレス表示設定
		 * @param {Object} state 状態
		 * @param {Boolean} flg プログレス表示フラグ
		 */
		setProgressFlg(state, flg) {
			state.progressFlg = flg;
		},
		/**
		 * 一覧の表示ページ番号設定
		 * @param {Object} state 状態
		 * @param {String} currentPage 一覧の表示ページ番号
		 */
		setCurrentPage(state, currentPage) {
			state.currentPage = currentPage;
		},
		/**
		 * 一覧の表示件数設定
		 * @param {Object} state 状態
		 * @param {String} displayCount 一覧の表示件数
		 */
		setDisplayCount(state, displayCount) {
			state.displayCount = displayCount;
		},
		/**
		 * 一覧の並び替え設定
		 * @param {Object} state 状態
		 * @param {String} sortOrder 一覧の並び替え
		 */
		setSortOrder(state, sortOrder) {
			state.sortOrder = sortOrder;
		},
		/**
		 * モバイル表示設定
		 * @param {Object} state 状態
		 * @param {Boolean} flg モバイル表示フラグ
		 */
		setMobileFlg(state, flg) {
			state.mobileFlg = flg;
		},
		/**
		 * ブラウザバックフラグ設定
		 * @param {Object} state 状態
		 * @param {Boolean} flg ブラウザバックフラグ
		 */
		setBrowserBackFlg(state, flg) {
			state.browserBackFlg = flg;
		},
		// ページング情報を初期化
		clearPage(state) {
			state.currentPage = 0;
		},
		/**
		 * 画面間パラメータ登録
		 * @param {Object} state 状態
		 * @param {Object} {id, params} 登録ID, パラメータ
		 */
		addViewParams(state, {id, params}) {
			state.viewParams[id] = params;
		},
		/**
		 * 画面間パラメータ初期化
		 * @param {Object} state 状態
		 */
		clearViewParams(state) {
			state.viewParams = {};
		},
		/**
		 * 画面間パラメータ削除
		 * @param {Object} state 状態
		 * @param {String} id 削除ID
		 */
		deleteParams(state, id){
			delete state.viewParams[id];
		},
	},
	actions: {
	},
	modules: {
	}
}